import ListViewIcon from 'atoms/Icons/ListViewIcon';
import MapIcon from 'atoms/Icons/MapIcon';
import TileViewIcon from 'atoms/Icons/TileViewIcon';
import TextButton from 'atoms/TextButton';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStore } from 'stores/store';
import { ViewModeCookieName } from 'utils/globalTypes';
import usePageView from 'utils/hooks/usePageView';

import s from './SwitchTableViewBar.module.scss';

const SwitchTableViewBar = ({
  showTableView = true,
  showMapView = true,
  showGalleryView = true,
  cookieName = 'assetBrowsingView'
}: {
  showTableView?: boolean;
  showMapView?: boolean;
  showGalleryView?: boolean;
  cookieName?: ViewModeCookieName;
}) => {
  const { AssetStore } = useStore();
  const { tableView, mapView, onShowMap, onCloseMap } = usePageView({
    cookieName
  });

  const setTableView = (view: boolean) => {
    AssetStore.setAssetBrowsingTableView(view, cookieName);
  };

  const showTile = () => {
    setTableView(false);
    onCloseMap();
  };
  const showTable = () => {
    setTableView(true);
    onCloseMap();
  };
  return (
    <div className={s.SwitchTableViewBar}>
      {showGalleryView && (
        <TextButton
          className={s.SwitchTableViewBar__item}
          isActive={!tableView && !mapView}
          icon={<TileViewIcon />}
          onClick={showTile}
        >
          Tile View
        </TextButton>
      )}
      {showMapView && (
        <TextButton
          className={s.SwitchTableViewBar__item}
          isActive={mapView}
          icon={<MapIcon />}
          onClick={onShowMap}
        >
          Map View
        </TextButton>
      )}
      {showTableView && (
        <TextButton
          className={s.SwitchTableViewBar__item}
          isActive={tableView}
          icon={<ListViewIcon />}
          onClick={showTable}
        >
          Table View
        </TextButton>
      )}
    </div>
  );
};

export default observer(SwitchTableViewBar);
